import React, { FC, useEffect, useState } from 'react';
import { Avatar, Select, Tag } from 'antd';
import { useConnection } from '../connection/connection';
import { UserAvatar } from './UserAvatar';
import classNames from 'classnames';
import { set } from 'radash';
import { useBusinessContext } from '../context/BusinessContext';

type Props = {
  mode?: 'multiple' | 'tags' | undefined;
  from?: Date;
  to?: Date;
  shiftId?: number;
  value?: string[] | string;
  onChange?: (value?: string[] | string) => void;
  allowClear?: boolean;
  placeholder?: string;
};

export const UserSelect: FC<Props> = (props) => {
  const business = useBusinessContext();
  const [users] = useState<any[]>(Object.values(business.users));
  return (
    <Select
      allowClear={props.allowClear}
      size="large"
      placeholder={props.placeholder}
      style={{ width: '100%', maxWidth: '100%' }}
      value={props.value}
      onChange={props.onChange}
      showSearch={true}
      mode={props.mode}
      filterOption={(inputValue, option) => {
        return !!option && option.user.includes(inputValue.toLowerCase());
      }}
      options={users.map((u) => ({
        value: u.userId,
        user: `${u.name}`.toLowerCase(),
        label: (
          <div className="flex gap-2 items-center max-w-[calc(100% - 50px)]">
            <UserAvatar size="small" user={u} />
            <span
              className={classNames({
                'text-red-500': u.status === 'Inactive',
              })}
            >
              {u.name}
            </span>
          </div>
        ),
      }))}
    />
  );
};
